import React from 'react'
import { themeConstants } from '@/styles/theme-constants.ts'
import { FadeView } from '@/common/anim/fade-view.tsx'
import { RankingCard, RankCardColors } from './ranking-card.tsx'
import { RankCardData } from './ranking-card.types.ts'

interface RankingSelfCardProps {
  data: RankCardData
  returnPctText: string
  cumulativePnlText: string
  dailyPnlText: string
  dailyLabel: string
  colors: RankCardColors
  // Opaque surface so the pinned card doesn't show rows through it.
  backgroundColor?: string
  // Shown only while the inline self row is scrolled out of the viewport
  // (above or below); hidden — and taking no layout space — when it is visible.
  visible: boolean
}

// Bottom floating self-position card. Rendered once as the last child of the
// card list and pinned to the container's bottom edge via `sticky`. The
// container toggles `visible` from an IntersectionObserver on the inline self
// row, so the card surfaces whenever that row leaves the viewport in either
// direction.
export const RankingSelfCard: React.FC<RankingSelfCardProps> = React.memo(
  ({
    data,
    returnPctText,
    cumulativePnlText,
    dailyPnlText,
    dailyLabel,
    colors,
    backgroundColor,
    visible,
  }) => (
    <FadeView
      visible={visible}
      style={{
        display: 'block',
        position: 'sticky',
        bottom: themeConstants.sizeXS,
        zIndex: 2,
      }}
    >
      <RankingCard
        data={data}
        returnPctText={returnPctText}
        cumulativePnlText={cumulativePnlText}
        dailyPnlText={dailyPnlText}
        dailyLabel={dailyLabel}
        colors={colors}
        elevated
        backgroundColor={backgroundColor}
      />
    </FadeView>
  )
)
